var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCurrency = function SvgCurrency(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M3.792 7.04v.218q0 .785-.291 1.571-.29.771-1.105 1.571h6.138V12H.359v-1.6Q1.392 9.382 1.77 8.64q.378-.757.378-1.41 0-.103-.014-.19H.054V5.76h1.774a6 6 0 0 0-.16-.436q-.16-.408-.363-1.048a2.5 2.5 0 0 1-.117-.785 2.6 2.6 0 0 1 .51-1.542A3.56 3.56 0 0 1 3.05.8 4 4 0 0 1 4.883.364q1.12 0 1.963.465.86.466 1.324 1.324.466.858.466 2.022H6.832q0-1.12-.466-1.659-.465-.538-1.483-.538-.814 0-1.353.48-.524.466-.524 1.15 0 .29.073.508l.146.466q.29.945.349 1.178h2.88v1.28z"
  })));
};
export default SvgCurrency;